import React from "react"
import Whatsapp from "../Icons/Whatsapp"
import "./BotonWhatsappFlotante.scss"

const BotonWhatsappFlotante = ({ href, className = "" }) => {
  if (!href) return null

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Escríbenos por WhatsApp"
      className={`boton-whatsapp-flotante ${className}`}
    >
      <Whatsapp />
    </a>
  )
}

export default BotonWhatsappFlotante
